import React from 'react';
import { motion } from 'framer-motion';
import { PrimaryButton } from './PrimaryButton';
import { RangeSlider } from './RangeSlider';
import { FollicleCluster } from './FollicleCluster';
import { AMH_RANGE, WEIGHT_RANGE, responseTendency, zoneFor, zoneLabels } from '../../utils/responseTendency';
type MiniSimScreenProps = {
  amh: number;
  weight: number;
  onAmh: (v: number) => void;
  onWeight: (v: number) => void;
  onNext: () => void;
};
export function MiniSimScreen({
  amh,
  weight,
  onAmh,
  onWeight,
  onNext
}: MiniSimScreenProps) {
  const position = responseTendency(amh, weight);
  const zone = zoneFor(position);
  return <div className="flex h-full flex-col" data-id="element-771" data-mp="3kxkbvo1j28lp">
      <h2 className="text-[30px] font-semibold leading-[1.04] tracking-[-0.035em] text-ink" data-id="element-772" data-mp="3pxf01jtx4k32">
        Change the patient.
        <br data-id="element-773" data-mp="108mhpqsvv04i" />
        See the challenge.
      </h2>

      <div className="mt-5" aria-live="polite" data-id="element-774" data-mp="107uxtd8nequ2">
        <FollicleCluster position={position} zone={zone} data-id="element-775" data-mp="156o86wsn21q0" />
        <div className="relative mt-3 h-4" data-id="element-776" data-mp="159agiyncsl9a">
          <div className="absolute inset-x-0 top-1/2 flex h-[4px] -translate-y-1/2 overflow-hidden rounded-full" data-id="element-777" data-mp="atcfb17d4lqz">
            <span className="flex-1 bg-ink/10" data-id="element-778" data-mp="6sip216g6uux" />
            <span className="w-[32%] bg-rx/70" data-id="element-779" data-mp="6pmpy9iv604w" />
            <span className="flex-1 bg-ink/10" data-id="element-780" data-mp="1rbg3yskjpmo" />
          </div>
          <motion.span className="absolute top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-ink shadow-[0_1px_4px_rgba(28,29,34,0.3)]" animate={{
          left: `${position * 100}%`
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-781" data-mp="3syxscftct0f5" />
        </div>
        <div className="mt-2 grid grid-cols-3 font-mono text-[9px] leading-tight tracking-[0.08em] text-graphite" data-id="element-782" data-mp="3f8c5kg0s46bz">
          <span data-id="element-783" data-mp="3a9r98rone6st">← LOWER</span>
          <span className="text-center text-rx" data-id="element-784" data-mp="3a6d4jcsihli7">TARGET ZONE</span>
          <span className="text-right" data-id="element-785" data-mp="358ldekzoy3f2">HIGHER →</span>
        </div>
        <p className={`mt-3 text-center text-[15px] font-semibold tracking-[-0.01em] ${zone === 'target' ? 'text-rx' : 'text-ink'}`} data-id="element-786" data-mp="309qjoo06qug6">
          {zoneLabels[zone]}
        </p>
      </div>

      <div className="mt-4 space-y-2" data-id="element-787" data-mp="2vl7kizc3dfcj">
        <RangeSlider label="AMH" unit="pmol/L" min={AMH_RANGE.min} max={AMH_RANGE.max} value={amh} onChange={onAmh} data-id="element-788" data-mp="2vn29qpuebtmf" />
        <RangeSlider label="BODY WEIGHT" unit="kg" min={WEIGHT_RANGE.min} max={WEIGHT_RANGE.max} value={weight} onChange={onWeight} data-id="element-789" data-mp="2hnj4q5wvsyec" />
      </div>
      <p className="mt-2 text-[11px] leading-snug text-graphite" data-id="element-790" data-mp="39cduxqgwsxe7">
        AMH drives expected responsiveness most. Body weight shapes the dose, not the response on its own.
      </p>

      <div className="mt-auto pt-4" data-id="element-791" data-mp="30ku0hgjb19p1">
        <PrimaryButton onClick={onNext} data-id="element-792" data-mp="30jiuda2dzpur">SEE THE REKOVELLE APPROACH</PrimaryButton>
      </div>
    </div>;
}